exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".broadcast-status[data-v-0f6aea58]{display:inline-block;position:relative;padding-left:10px}.broadcast-status[data-v-0f6aea58]:before{content:\"\";height:7px;width:7px;border-radius:50%;position:absolute;left:0;top:-2px;bottom:0;margin:auto;background-color:#2c3e4f}.broadcast-status.live[data-v-0f6aea58]{text-transform:uppercase;color:#d0021b;font-weight:700}.broadcast-status.live[data-v-0f6aea58]:before{background-color:#7ed321}", ""]);

// exports
